// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"701b2ca3","654":"53f06c7e","700":"75b889a2","718":"fc471bbb","842":"ba447e24","953":"acaebde5"}[chunkId] + ".css";
};